import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Theme } from 'ui_system/theme';

const defaultButtonStyles = (props) => css`
  cursor: pointer;
  background-color: ${Theme.colors.linksDesignElementsBaseColor};
  color: white;
  border-radius: 4px;
  font-size: 16px;
  padding: 10px;
  justify-self: center;
  border: solid 1px ${Theme.colors.linksDesignElementsBaseColor};
  ${(props.modifiers || []).map((func) => func(props))}
`;

const DefaultButton = styled('button')`
  ${defaultButtonStyles};
`;

export const LinkButton = styled('a')`
  ${defaultButtonStyles};
  display: inline-block;
  padding: 11px 35px;

  &:hover {
    color: white;
  }
`;

export const red = (_props) => css`
  background-color: #cf202f;
  border-color: #cf202f;

  :hover,
  :visited,
  :active {
    color: white;
  }
`;

export const fullWidth = (_props) => css`
  width: 100%;
`;

export const alignCenter = (_props) => css`
  display: block;
  margin: auto;
`;

export default DefaultButton;
